"use client"

import {upgradeRequiredHeader} from "@/app/auth/limits";
import {notifyForbidden, notifyUpgradeRequired} from "@/app/components/Can";

export async function jr(r: Response) {
  if (r.ok) {
    return r.json()
  }
  if (r.status === 403) {
    if (r.headers.get(upgradeRequiredHeader) === "true") {
      notifyUpgradeRequired()
    } else {
      notifyForbidden()
    }
  }
  let message = r.statusText || `Request failed with status ${r.status}`
  try {
    const body = await r.json()
    message = body.error || body.message || body.statusText || message
  } catch {
  }
  throw new Error(message)
}
